var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42667 3.36356C7.71333 5.20356 9.20667 6.61022 11.06 6.79689M1.5 14.6636H13.5M8.34 2.39689L2.86667 8.19022C2.66 8.41022 2.46 8.84356 2.42 9.14356L2.17333 11.3036C2.08667 12.0836 2.64667 12.6169 3.42 12.4836L5.56667 12.1169C5.86667 12.0636 6.28667 11.8436 6.49333 11.6169L11.9667 5.82356C12.9133 4.82356 13.34 3.68356 11.8667 2.29022C10.4 0.910223 9.28667 1.39689 8.34 2.39689Z",
    stroke: "#D9D9D9",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.80ab9c9d19c6d9e14f5622df84ff272f.svg";
export { ForwardRef as ReactComponent };